document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-drawer]');
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
    const open = drawer.classList.toggle('is-open'); button.setAttribute('aria-expanded', String(open));
  }));
  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-slide]')]; if (slides.length < 2) return;
    let index = 0;
    const show = (next) => { slides[index].classList.remove('is-active'); index = (next + slides.length) % slides.length; slides[index].classList.add('is-active'); };
    slider.querySelector('[data-prev]')?.addEventListener('click', () => show(index - 1));
    slider.querySelector('[data-next]')?.addEventListener('click', () => show(index + 1));
    setInterval(() => show(index + 1), Number(slider.dataset.delay || 6000));
  });
});
